import React, { useState } from 'react';

const LazyImage = ({ src, alt, className, style, onLoad, onError }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = (e) => {
    setIsLoading(false);
    onLoad?.(e);
  };

  const handleError = (e) => {
    setIsLoading(false);
    setHasError(true);
    onError?.(e);
  };

  if (hasError) {
    return (
      <div className={`image-error-placeholder ${className}`} style={style}>
        <i className="fas fa-image"></i>
        <span>Image unavailable</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`${className} ${isLoading ? 'loading' : 'loaded'}`}
      style={style}
      onLoad={handleLoad}
      onError={handleError}
      loading="lazy"
    />
  );
};

export default LazyImage;
